export type FileFieldValue = {
  _id: string;
  name: string;
  length: number;
  contentType: string;
  hash: string;
  pendingContentExtraction: boolean;
  contentText?: string;
};
